export function axiosPostHandler (url, args = {}, formdata = {}, base = 'heychat', headers = {}) {
  return window.MiniProgramSDK.sendRequest({
    url,
    method: 'POST',
    params: args,
    body: formdata,
    base,
    headers
  })
}

export function axiosGetHandler (url, args = {}, base = 'heychat', headers = {}) {
  return window.MiniProgramSDK.sendRequest({
    url,
    method: 'GET',
    params: args,
    base,
    headers
  })
}

export const default_args = { 
  _notip: true, 
}